var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expanded-viewport overflow-hidden"},[_c('AppbarFixed',{attrs:{"hasBackButton":true}}),_c('div',{staticClass:"mt-5"},[_c('pdf',{attrs:{"src":_vm.url}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }